import { Component, Prop, h, Element } from '@stencil/core';

@Component({
  tag: 'spw-card-image',
  styleUrl: 'spw-card-image.scss',
  shadow: true,
})
export class SpwCardImage {
  @Element() el: HTMLSpwCardImageElement;
  /** Label spécifié dans la carte */
  @Prop() label?: string;

  componentDidLoad() {
    const card = this.el.closest('spw-card');
    if (card) {
      card.addEventListener('mouseenter', () => this.onCardHover(true));
      card.addEventListener('mouseleave', () => this.onCardHover(false));
    }
  }

  private onCardHover(hovered) {
    const icon = this.el.shadowRoot.querySelector('.spw-card-image');
    if (icon) {
      if (hovered) {
        icon.classList.add('--is-hovered');
      } else {
        icon.classList.remove('--is-hovered');
      }
    }
  }

  render() {
    return (
      <div class="spw-card-image">
        {this.label && <span class="spw-card-image__label">{this.label}</span>}
        <slot></slot>
        <div class="spw-card-image__icon">
          <spw-icon icon="fa-plus"></spw-icon>
        </div>
      </div>
    );
  }
}
